import { LabelButtonVariant } from '@/components/forms/buttons/types/ButtonTypes'
import { LocaleMessages, TranslateResult } from 'vue-i18n'

export interface ActionBarButton {
  icon?: string
  class?: string
  mode?: string
  tooltip: TranslateResult | string | LocaleMessages
  action: ActionName
  prependIcon?: string
  enabled: boolean | (() => void)
  hidden?: boolean
  variant?: LabelButtonVariant
  isContextMenuOption?: boolean
}

export enum ActionBarButtonMode {
  ROUND = 'round',
  SQUARE = 'square'
}

export enum ActionName {
  ACCEPT = 'accept',
  ADD = 'add',
  BIND = 'bind',
  CANCEL = 'cancel',
  CLOSE = 'close',
  CONVERT_TO_CUSTOMER_INVOICE = 'converToCustomerInvoice',
  CUSTOM_OPTION = 'customOption',
  DISCARD = 'discard',
  DOWNLOAD = 'download',
  DUPLICATE_EXPEDIENT = 'duplicateExpedient',
  EDIT = 'edit',
  FILTER_REPORT = 'filterReport',
  FINISH_INVOICE_GENERATION = 'finishInvoiceGeneration',
  GENERATE_DOCUMENT = 'generateDocument',
  IMPORT = 'import',
  NEW = 'new',
  NEXT = 'next',
  OPEN_IN_LEXNET = 'openInLexnet',
  OPEN_LF_MAIL = 'openLfMail',
  OPEN_WINDOW = 'openWindow',
  PREV = 'previous',
  PRINT = 'printInvoice',
  PRINT_EXPEDIENTS = 'printExpedients',
  REMOVE = 'remove',
  RECTIFY_CUSTOMER_INVOICE = 'rectifyCustomerInvoice',
  SAVE = 'save',
  SAVE_FACTURA_E = 'saveFacturaE',
  SAVE_AS = 'saveAs',
  SEND_EMAIL = 'sendEmail',
  SEND_FACTURA_E = 'sendFacturaE',
  SEND_INTERN_NOTIFICATION = 'sendInternNotification',
  UNBIND = 'unbind'
}
